import type { StoreUserRole } from "../types";

export const ADD_USER_ROLE_OPTIONS: StoreUserRole[] = [
  "manager",
  "operator",
];

export const EDIT_USER_ROLE_OPTIONS: StoreUserRole[] = [
  "manager",
  "operator",
];

export const OWNER_USER_ROLE_OPTIONS: StoreUserRole[] = ["owner"];

const LEGACY_USER_ROLE_OPTIONS: StoreUserRole[] = ["manager", "operator"];

export const canAssignReconciliationManagerRole = (actorRole?: string | null, isSuperAdmin = false) => {
  const normalizedRole = normalizeUserRole(actorRole);
  return isSuperAdmin || normalizedRole === "owner";
};

export const getAssignableUserRoleOptions = (actorRole?: string | null): StoreUserRole[] => (
  canAssignReconciliationManagerRole(actorRole) ? ADD_USER_ROLE_OPTIONS : LEGACY_USER_ROLE_OPTIONS
);

export const userRolePrivilegeRank: Record<string, number> = {
  owner: 0,
  admin: 0,
  manager: 2,
  operator: 4,
  employee: 5,
};

export const normalizeUserRole = (role?: string | null) => String(role || "").toLowerCase();

export const isRecoOfficerUser = (user?: { role?: string | null; can_approve_reconciliation?: boolean } | null) => {
  const normalizedRole = normalizeUserRole(user?.role);
  return normalizedRole === "reco_officer" ||
    normalizedRole === "reconciliation_manager" ||
    (normalizedRole === "manager" && Boolean(user?.can_approve_reconciliation));
};

export const getUserPermissionLabels = (user?: { role?: string | null; can_approve_reconciliation?: boolean } | null) => (
  isRecoOfficerUser(user) ? ["Reco Officer"] : []
);

export const getUserRolePrivilegeRank = (user?: { role?: string | null; can_approve_reconciliation?: boolean } | null) => {
  if (isRecoOfficerUser(user)) {
    return 1;
  }

  return userRolePrivilegeRank[normalizeUserRole(user?.role)] ?? 99;
};

export const formatUserRole = (role?: string) => {
  const normalizedRole = normalizeUserRole(role);

  if (!normalizedRole) {
    return "-";
  }

  if (normalizedRole === "reco_officer" || normalizedRole === "reconciliation_manager") {
    return "Manager";
  }

  return normalizedRole.charAt(0).toUpperCase() + normalizedRole.slice(1);
};

export const isPinLoginAllowedForRole = (role?: string) => normalizeUserRole(role) === "operator";

export const isEmailRequiredForUserRole = (role?: string) => {
  const normalizedRole = normalizeUserRole(role);
  return normalizedRole === "manager" || normalizedRole === "owner";
};
